// extracted by mini-css-extract-plugin
export default {"container":"AreaDetail_container__3p2x3","header":"AreaDetail_header__ZSZ74","backButton":"AreaDetail_backButton__vHA2Q","dashboard":"AreaDetail_dashboard__bpR+e"};